import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';

import { ServiceError, useError } from 'Src/network/useError';

import service, { FeeOrGratuity } from './feesAndGratuitiesService';

const queryKeys = {
  feesAndGratuities: ['POS:GET:Surcharges'],
};

const useFeesAndGratuitiesQuery = <TData = FeeOrGratuity[]>(select?: (allFeesAndGratuities: FeeOrGratuity[]) => TData) => {
  const { t } = useTranslation();
  const { parseError } = useError({ activity: t('feesAndGratuities.errors.getAll') });
  return useQuery<FeeOrGratuity[], ServiceError, TData>({
    queryKey: queryKeys.feesAndGratuities,
    queryFn: async () => {
      try {
        const data = await service.getAll({});
        return data.items;
      } catch (e) {
        throw parseError(e);
      }
    },
    select,
  });
};

const useFeesAndGratuties = {
  query: {
    getAll: useFeesAndGratuitiesQuery,
  },
};

export { useFeesAndGratuties };
